import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import { THUMBNAILS_URL } from 'api/apiConstants'
import wrapper from 'redux/store'
import {
  getInvestmentsCall,
  // getReviewsCall,
  getIndustryInfoCall,
  getFeedCall,
  getAvgChangesReturnCall,
  getIndustryCall,
  getAssetsCompareManyCall,
  getPlatformCall,
  getIndustriesAllCall,
  getAssetPagesCall,
  getIndustriesCall,
  getPlatformReviewsCall,
  getAssetsTagsCall,
  getAssetPageCall,
  getArticlesCall,
  getReviewsCall
} from 'api/calls'
import { rankInIndustriesNew } from 'utils/checkers'
import { isBlackListSlugs } from 'modules/home/HomePage/homePageUtils'
import { redis } from 'utils/redis'
import { withRedis } from 'api/callConstructor'

const HeadTags = dynamic(() => import('components/app/HeadTags/HeadTags'))
const PlatformPage = dynamic(() => import('modules/discover/PlatformPage/PlatformPage'))
const PlatformPageNew = dynamic(() => import('modules/discover/PlatformPageNew/PlatformPageNewContainer'))

const PlatformPageContainer = props => {
  const {
    currentInvestment: { name, description, logo, totalReviews, averageRating, slug },
    newPlatform
  } = props

  const updatedProps = {
    ...props
  }

  return (
    <>
      <HeadTags
        title={name}
        description={description}
        schema={{ name, logo, totalReviews, averageRating }}
        thumbnail={`${THUMBNAILS_URL}/${slug.toLowerCase()}.jpg`}
      />
      {newPlatform ? <PlatformPageNew {...updatedProps} /> : <PlatformPage {...updatedProps} />}
    </>
  )
}

PlatformPageContainer.propTypes = {
  currentInvestment: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    publishedStatus: PropTypes.string,
    logo: PropTypes.string,
    totalReviews: PropTypes.number,
    averageRating: PropTypes.number,
    slug: PropTypes.string
  }),
  newPlatform: PropTypes.bool
}

PlatformPageContainer.defaultProps = {
  currentInvestment: {
    name: '',
    description: '',
    publishedStatus: '',
    logo: '',
    totalReviews: 0,
    averageRating: 0,
    slug: ''
  },
  newPlatform: false
}

export const getStaticPaths = async () => {
  // Call to get investments
  const investments = await withRedis(redis, getInvestmentsCall(), '/discover/slug')
  // if (!investments.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/entries. ${investments.status} ${investments.message}`
  //   )

  // Generate platforms paths to prerender routes
  const paths = investments.success ? investments.result?.map(({ slug }) => ({ params: { slug } })) : []

  return {
    paths,
    fallback: true
  }
}

export const getStaticProps = wrapper.getStaticProps(async ({ params: { slug } }) => {
  const assetPageAll = await withRedis(redis, getAssetPagesCall(), `/discover/${slug}`)
  // if (!assetPageAll.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/asset-pages?publishedStatus=published. ${assetPageAll.status} ${assetPageAll.message}`
  //   )

  const articlesPickFields =
    '&pick-fields=[*]slug&pick-fields=[*]title&pick-fields=[*]logo&pick-fields=[*]shortDescription&pick-fields=[*]published&pick-fields=[*]type'

  const articles = await withRedis(redis, getArticlesCall(articlesPickFields), `/404`)
  // All asset pages
  const assetPages = await Promise.all(
    assetPageAll.result.map(async assetPageSlug => {
      const assetPage = await withRedis(redis, getAssetPageCall(assetPageSlug), `/discover/${slug}`)
      // if (!assetPage.success)
      //   throwSentryError(
      //     `Error: API URL: https://cms.moneymade.io/api/asset-pages/${assetPageSlug}. ${assetPage.status} ${assetPage.message}`
      //   )

      return assetPageSlug ? assetPage.result : null
    })
  )

  // Call to get investments
  const investments = await withRedis(redis, getInvestmentsCall(), `/discover/${slug}`)
  // if (!investments.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/entries. ${investments.status} ${investments.message}`
  //   )

  const assetsTags = await withRedis(redis, getAssetsTagsCall(), `/discover/${slug}`)
  // if (!assetsTags.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/asset-tags. ${assetsTags.status} ${assetsTags.message}`
  //   )

  const industriesAll = await withRedis(redis, getIndustriesAllCall(), `/discover/${slug}`)
  // if (!industriesAll.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/industries. ${industriesAll.status} ${industriesAll.message}`
  //   )

  const industries = await withRedis(redis, getIndustriesCall(), `/discover/${slug}`)
  // if (!industries.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/industries. ${industries.status} ${industries.message}`
  //   )

  const assetPagesSlugs = await withRedis(redis, getAssetPagesCall(), `/discover/${slug}`)
  // if (!assetPagesSlugs.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/asset-pages?publishedStatus=published. ${assetPagesSlugs.status} ${assetPagesSlugs.message}`
  //   )

  const slugIndustries = [
    ...new Set(industriesAll.result.map(({ dataSlug }) => `${dataSlug ? `slugs=${dataSlug}` : ''}`))
  ].join('&')

  const avg = await withRedis(
    redis,
    getAvgChangesReturnCall(slugIndustries.replace('&slugs=&slugs=', '&slugs=')),
    `/discover/${slug}`
  )
  // if (!avg.success)
  //   throwSentryError(
  //     `Error: API URL: https://mm-industries.moneymade.io/industry/average-changes?${slugIndustries.replace(
  //       '&slugs=&slugs=',
  //       '&slugs='
  //     )}. ${avg.status} ${avg.message}`
  //   )

  const platformReviews = await withRedis(redis, getPlatformReviewsCall(), `/discover/${slug}`)
  // if (!platformReviews.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/platform-reviews?_sort=created_at:DESC&publishedStatus=published. ${platformReviews.status} ${platformReviews.message}`
  //   )

  // Find investment by slug
  const currentInvestment = investments.result?.find(({ slug: platformSlug }) => platformSlug === slug)

  if (currentInvestment?.publishedStatus === 'draft' || currentInvestment?.publishedStatus === undefined) {
    return { notFound: true }
  }
  // Get reviews for current investment
  const reviews = await getReviewsCall(
    {
      platformId: currentInvestment?.id || ''
    },
    `/discover/${slug}`
  )()

  // if (!reviews.success)
  //   throwSentryError(
  //     `Error: API URL: https://us-central1-benchmark-media.cloudfunctions.net/getReviews. ${reviews.status} ${reviews.message}`
  //   )

  // Get feed by tags
  const newsWithTags = await withRedis(
    redis,
    getFeedCall(
      `includeNonFeatured=true&perPage=7&isTagsAsString=true&tags=${currentInvestment?.name},${currentInvestment?.industry}`
    ),
    `/discover/${slug}`
  )
  // if (!newsWithTags.success)
  //   throwSentryError(
  //     `Error: API URL: https://cms.moneymade.io/api/parsed-contents?publishedStatus=published&includeNonFeatured=true&perPage=7&isTagsAsString=true&tags=${currentInvestment?.name},${currentInvestment?.industry}. ${newsWithTags.status} ${newsWithTags.message}`
  //   )

  // Get feed by tags
  const news = await withRedis(
    redis,
    getFeedCall('includeNonFeatured=true&perPage=7&isTagsAsString=true'),
    `/discover/${slug}`
  )
  // if (!news.success)
  //   throwSentryError(
  //     `Error: API URL:https://cms.moneymade.io/api/parsed-contents?publishedStatus=published&includeNonFeatured=true&perPage=7&isTagsAsString=true. ${news.status} ${news.message}`
  //   )

  // Get industry info (not CMS)
  const industriesInfoApi = await withRedis(
    redis,
    getIndustryInfoCall(currentInvestment?.industrySlug),
    `/discover/${slug}`
  )
  // if (!industriesInfoApi.success)
  //   throwSentryError(
  //     `Error: API URL: https://mm-industries.moneymade.io/industry/info/${currentInvestment?.industrySlug}. ${industriesInfoApi.status} ${industriesInfoApi.message}`
  //   )

  // Get info about industry of the platform
  const investmentIndustry = industries.result.find(({ slug: localSlug }) => localSlug === currentInvestment?.urlSlug)

  // // Get platform review
  const investmentReview = platformReviews.result.find(({ slug: localSlug }) => localSlug === `${slug}-review`)
  // // // Get full inustry info
  const industriesInfo = industriesInfoApi.success ? { ...investmentIndustry, ...industriesInfoApi.result } : null
  // // Get asset page slug for current platform
  const assetPageSlug = assetPagesSlugs.result?.find(
    slugs =>
      slugs ===
      (currentInvestment?.industries[0]?.assetSlug ||
        currentInvestment?.industries[1]?.assetSlug ||
        currentInvestment?.industries[2]?.assetSlug)
  )

  const assetPageTextBlock =
    assetPageSlug !== 'nft'
      ? assetPages
          .find(({ slug: slugPage }) => slugPage === assetPageSlug)
          ?.content.find(({ type }) => type === 'TextBlock')
      : assetPages
          .find(({ slug: slugPageNew }) => slugPageNew === assetPageSlug)
          ?.content.find(({ type }) => type === 'Faq')
          ?.blocks.find(({ heading }) => heading === 'How you’re taxed')

  let webparts = []
  let returnObj = {}

  if (currentInvestment?.newDiscover) {
    const platform = await withRedis(redis, getPlatformCall(slug, '?pick-fields=webparts'), `/discover/${slug}`)
    // if (!platform.success)
    //   throwSentryError(
    //     `Error: API URL: https://cms.moneymade.io/api/entries/${slug}?pick-fields=webparts. ${platform.status} ${platform.message}`
    //   )

    if (platform.success) {
      webparts = platform.result?.webparts

      returnObj = await webparts?.reduce(async (returnData, { type, dataSlug, disable }) => {
        if (disable) return returnData

        switch (type) {
          case 'snapshot': {
            if (!dataSlug) {
              return {
                ...(await returnData)
              }
            }
            // for black list slugs use statis data
            if (isBlackListSlugs(dataSlug)) {
              const industry = await withRedis(
                redis,
                getIndustryCall(dataSlug, '?pick-fields=change'),
                `/discover/${slug}`
              )
              // if (!industry.success)
              //   throwSentryError(
              //     `Error: API URL: https://mm-industries.moneymade.io/industry/info/${dataSlug}?pick-fields=change. ${industry.status} ${industry.message}`
              //   )

              return {
                ...(await returnData),
                assetCompare: {},
                industryChange: industry.result?.change || '0%'
              }
            }
            // generate query params for current dataSlug
            const queryParams = `slugs=${dataSlug}`
            // Get Assets Compare data
            const assetsCompare = await withRedis(redis, getAssetsCompareManyCall(queryParams), `/discover/${slug}`)
            // if (!assetsCompare.success)
            //   throwSentryError(
            //     `Error: API URL: https://mm-industries.moneymade.io/industry/compare/many?${queryParams}. ${assetsCompare.status} ${assetsCompare.message}`
            //   )
            return {
              ...(await returnData),
              assetCompare: assetsCompare.result || {},
              industryChange: ''
            }
          }

          default:
            return returnData
        }
      }, {})
    }
  }
  const newInvestment = { ...currentInvestment, webparts }

  const rankIndustries = rankInIndustriesNew(investments.result, currentInvestment)

  const oldPlatform = !currentInvestment?.newDiscover
    ? {
        platformReview: investmentReview || {},
        assetsTags: assetsTags.result,
        rankIndustries: rankIndustries || {},
        news: newsWithTags.result?.items?.length ? newsWithTags.result?.items : news.result?.items,
        assetSection: assetPageTextBlock || {},
        industriesInfo
      }
    : {}

  return {
    props: {
      key: currentInvestment?.id, // DON'T CHANGE THE PROPS. Need for state updates while changing dynamic routes
      currentInvestment: newInvestment,
      reviews: reviews.success ? reviews.result : [],
      assetPageSlug: assetPageSlug || '',
      industriesAvgAll: avg.success ? avg.result : {},
      newPlatform: currentInvestment?.newDiscover || false,
      articles: articles?.success ? articles.result.slice(0, 8) : [],
      ...oldPlatform,
      ...returnObj
    },
    revalidate: 3600 // 1 hour
  }
})

export default PlatformPageContainer
